import moment from "moment";

function getNowMonth(): string {
    return moment().format('YYYY-MM')
}

export default getNowMonth